/**
 * Platform Utilities
 *
 * Portable browser/platform detection for API requests.
 * Replaces common/config/utils browser detection with standard browser APIs.
 */

/**
 * Detect browser name from user agent string.
 * Used as `browser_context` parameter in API requests for fraud detection.
 */
const getBrowserName = (): string => {
  if (typeof window === 'undefined' || !navigator?.userAgent) return 'unknown';

  const ua = navigator.userAgent;

  if (ua.includes('Opera') || ua.includes('OPR')) return 'Opera';
  if (ua.includes('Edg')) return 'Edge';
  if (ua.includes('Chrome') && !ua.includes('Edg')) return 'Chrome';
  if (ua.includes('Safari') && !ua.includes('Chrome')) return 'Safari';
  if (ua.includes('Firefox')) return 'Firefox';
  if (ua.includes('MSIE') || ua.includes('Trident')) return 'Internet Explorer';

  return 'unknown';
};

/**
 * Browser context object — spread into API request bodies for fraud detection.
 *
 * @example
 * const requestBody = { amount: 100, ...browserContext };
 */
export const browserContext = { browser_context: getBrowserName() };

/**
 * Get client platform identifier for API requests.
 * Returns 'app' when loaded inside a native mobile app, 'Web' otherwise.
 *
 * Mobile apps append `pg_client` or `client_platform` query params to the URL.
 */
export const getClientPlatformForAPI = (): string => {
  if (typeof window === 'undefined') return 'Web';

  const params = new URLSearchParams(window.location.search);
  if (params.get('pg_client') || params.get('client_platform')) return 'app';

  return 'Web';
};
